export default __webpack_public_path__ + "static/media/note.0155fa57.svg";